// Tijden van de kaart "Verkopen gemist": hij staat langer naarmate er meer
// regels op staan. De CSS krijgt duur en vertraging als inline stijl mee.

// Eerst de kop, daarna elke regel om de beurt.
export const rowStartMs = 1100;
export const rowStepMs = 1000;

// Na de laatste regel: het totaal, even laten staan, en dan weg.
export const totalAfterMs = 500;
export const holdMs = 3200;
export const outMs = 600;

// Extra leestijd als er geen lijst is die de kaart vanzelf lang genoeg laat staan.
export const emptyHoldMs = 2200;

// Daarboven worden de kleinste verkopen één regel "en nog N verkopen".
export const maxRows = 5;

export function rowCount(saleCount) {
  return Math.min(saleCount, maxRows);
}

export function rowDelayMs(index) {
  return rowStartMs + index * rowStepMs;
}

export function missedSalesMs(saleCount) {
  const rows = rowCount(saleCount);
  const lastRow = rows ? rowDelayMs(rows - 1) : rowStartMs + emptyHoldMs;
  return lastRow + totalAfterMs + holdMs + outMs;
}
